import { CONSENT_VALIDATION_FIELD } from "./constants";

export const consentMessageBuilder = (fields, messageType) =>
  fields.map(field =>
    field.name === CONSENT_VALIDATION_FIELD.name &&
    field.type === CONSENT_VALIDATION_FIELD.type
      ? { ...field, title: messageType ? field.data[messageType] : "" }
      : field
  );
